import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Scrollchor } from 'react-scrollchor';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <Link to="#0">Contactos</Link>
        </li>
        <li>
        <Scrollchor animate={{offset: 20, duration: 2000}} to='Nosotros' >
          <Link to="">Nosotros</Link>
          </Scrollchor>
        </li>
        {/* <li>
          <Link to="#0">Productos</Link>
        </li> */}
        
      </ul>
    </nav>
  );
}

export default FooterNav;